module.exports = __webpack_public_path__ + "img/compare.d196717a.svg";